import type { Locale } from "../types/content";

export const locales: Locale[] = ["en", "ro", "he"];

export const localeLabels: Record<Locale, string> = {
  en: "EN",
  ro: "RO",
  he: "HE"
};

export const localeNames: Record<Locale, string> = {
  en: "English",
  ro: "Romana",
  he: "עברית"
};

export const rtlLocales: Locale[] = ["he"];

export const organization = {
  brandName: "Transition Bridge",
  publicDescriptor: "Moldova–Israel Sustainable Transition Initiative",
  legalNameRo: "Instituția Privată pentru Tranziție Durabilă",
  legalNameEn: "Private Institution for Sustainable Transition",
  legalNameHe: "המוסד הפרטי למעבר בר-קיימא",
  shortName: "TB",
  registrationStatus: "pre_registration" as "pre_registration" | "registered",
  registrationNumber: null as string | null,
  registrationDate: null as string | null,
  address: null as string | null,
  email: null as string | null,
  phone: null as string | null,
  socialLinks: [] as Array<{ label: string; href: string }>
};

export const ctaByRoute = [
  { match: "/moldova", label: "Request a Project Screening", flow: "moldova" },
  { match: "/israel", label: "Assess Moldova Fit", flow: "israel" },
  { match: "/programs/green-wine-moldova", label: "Discuss a Green Wine Pilot", flow: "green-wine" }
];
